import React from "react";
import classnames from "classnames";
import Tooltip from "features/Account/modules/Tooltips/Tootips";

export const DataItem = ({
  data,
  subData,
  title,
  titleClassName,
  dataClassName,
  tooltipId,
  tooltipTitle,
  openTooltipId,
  setOpenTooltipId,
}) => {
  return (
    <div>
      <div className="tw-flex tw-gap-1 tw-items-end">
        <div
          className={classnames(
            "tw-text-[16px] tw-font-bold tw-mb-[4px]",
            dataClassName
          )}
        >
          {data}
        </div>

        {subData !== undefined && subData !== null && (
          <div
            className={classnames(
              "tw-text-[14px] tw-font-normal tw-mb-[4px]",
              dataClassName
            )}
          >
            ({subData})
          </div>
        )}
      </div>

      <div className="tw-flex tw-gap-1 tw-items-center">
        <div
          className={classnames(
            "tw-text-[16px] tw-font-normal tw-text-[#272522]",
            titleClassName
          )}
        >
          {title}
        </div>
        {tooltipId && (
          <Tooltip
            id={tooltipId}
            displayTitle={tooltipTitle}
            open={openTooltipId === "click_rate"}
            setOpenTooltipId={setOpenTooltipId}
          />
        )}
      </div>
    </div>
  );
};
